module.exports = __webpack_public_path__ + "static/paper-transparent-cd3fcc36e422409daba55199da619ade.png";